export enum ListViewFilterControlElementType {
  Dropdown = 1,
  SearchBar = 2,
  DateRange = 3,
  Toggle = 4,
}